import { state } from './state';
import actions from './actions';
import mutations from './mutations';

const professionalIdentification = {
  state,
  actions,
  mutations,
};

export default professionalIdentification;
